import React from 'react';
import { ILoaderProps } from './types/ILoaderProps';
import styles from './Loader.module.scss';
import classNames from 'classnames';
import { useAppContext } from '../../../AppContext';
import styled, { css } from 'styled-components';
import { DictionaryType } from '../../types/DictionaryType';

const Loader = (props: ILoaderProps) => {
  const context = useAppContext();

  const { main, opacity, cssClass, hideContent } = props;
  const customClasses = prepareClassNames({
    cssClass,
    'loader--overlay': opacity,
    'hide-background': hideContent,
  });

  return (
    <Wrapper
      styles={context.styles}
      className={classNames(customClasses, styles.wrapper)}
      style={opacity ? { background: `rgba(255, 255, 255, ${opacity})` } : {}}
    >
      <div className={styles['lds-css']}>
        <div className={styles['lds-wedges']}>
          <div>
            <div>
              <div />
            </div>

            <div>
              <div />
            </div>

            <div>
              <div />
            </div>

            <div>
              <div />
            </div>
          </div>
        </div>
      </div>

      {main && <p className="loader__msg">Loading</p>}
    </Wrapper>
  );
};

const prepareClassNames = (classes: {}) => {
  return Object.entries(classes)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(' ');
};

const Wrapper = styled.div<{
  styles: DictionaryType<DictionaryType<string>>;
}>`
  ${(props) => {
    let styles = '';

    if (props.styles) {
      const brandColors = props.styles['general:colors'].brand;
      let loaderColor = '';

      if (props.styles['module:loader'].backgroundColor) {
        loaderColor = props.styles['module:loader'].backgroundColor;
      } else if (brandColors) {
        loaderColor = brandColors.split(',')[0];
      }

      if (loaderColor.length) {
        styles = `> div > div > div > div:nth-child(1) > div { background: ${loaderColor}; } ${styles}`;
        styles = `> div > div > div > div:nth-child(2) > div { background: ${loaderColor}; } ${styles}`;
        styles = `> div > div > div > div:nth-child(3) > div { background: ${loaderColor}; } ${styles}`;
        styles = `> div > div > div > div:nth-child(4) > div { background: ${loaderColor}; } ${styles}`;
      }
    }

    return css`
      ${styles}
    `;
  }}
`;

export default Loader;
